// ===================================
// INDEX.JS - IMPORTACIONES CORREGIDAS
// Archivo: src/index.js
// ===================================

import { initCarousel } from "./js/carousel.js";
import { initContactMap } from "./js/contactMap.js";

import bookingManager from "./js/booking.js";
// ...existing code...

// ...otros imports...
import contactFormManager from "./js/contactForm.js";
import complaintFormManager from "./js/complaintForm.js";

import footerContactFormManager from "./js/footerContactForm.js";

import { toggleFaq } from "./js/faq.js";
import { initTimeline } from "./js/3-hours.js";
import { initFourHoursTimeline } from "./js/4-hours.js";
import { initApuKatunkiTimeline } from "./js/apu-katunki.js";
import { initHalfDayTimeline } from "./js/half-day.js";
import { initSacredValleyTimeline } from "./js/yuchuy-qosqo.js";
import { initYanaqochaTimeline } from "./js/yanaqocha-qeullaqocha.js";
import "./js/contactMap.js";
// En tu src/index.js, agrega esta importación

// main.js - Archivo principal que importa los módulos
import { initializeNavigation } from "./js/navigation.js";

document.addEventListener("DOMContentLoaded", function () {
  console.log("🚀 Go Peru Now - Frontend cargado completamente");

  // Inicializar timeline de Sacred Valley (yuchuy-qosqo)
  if (typeof initSacredValleyTimeline !== "undefined") {
    initSacredValleyTimeline();
  }

  // Inicializar el carousel si existe en la página
  if (document.querySelector(".carousel")) {
    initCarousel();
  }

  // Inicializa el mapa de contacto si existe el div #map
  if (document.getElementById("map")) {
    initContactMap();
  }

  // Inicializar timeline de 3-hours
  if (typeof initTimeline === "function") {
    initTimeline();
  }

  // Inicializar timeline de 4-hours
  if (typeof initFourHoursTimeline === "function") {
    initFourHoursTimeline();
  }

  // Inicializar timeline de Apu Katunki
  if (typeof initApuKatunkiTimeline === "function") {
    initApuKatunkiTimeline();
  }

  // Inicializar timeline de Half Day
  if (typeof initHalfDayTimeline === "function") {
    initHalfDayTimeline();
  }

  // Inicializar timeline de Sacred Valley (yuchuy-qosqo)
  if (typeof initSacredValleyTimeline === "function") {
    initSacredValleyTimeline();
  }

  // Inicializar timeline de Yanaqocha & Qeullaqocha
  if (typeof initYanaqochaTimeline === "function") {
    initYanaqochaTimeline();
  }

  // Inicializar navegación
  initializeNavigation();

  // Asignar eventos FAQ de manera profesional
  document.querySelectorAll("[data-faq-id]").forEach((btn) => {
    btn.addEventListener("click", function () {
      const id = btn.getAttribute("data-faq-id");
      toggleFaq(id);
    });
  });

  // Manejar formulario de contacto (frontend only)
  const contactForm = document.getElementById("contactForm");
  if (contactForm) {
    contactForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const name = this.querySelector('[name="name"]').value.trim();
      const email = this.querySelector('[name="email"]').value.trim();
      const message = this.querySelector('[name="message"]').value.trim();

      if (!name || !email || !message) {
        alert("Por favor, completa todos los campos.");
        return;
      }

      alert("¡Gracias por tu mensaje! Te contactaremos pronto.");
      this.reset();
    });
  }

  // Footer contact form (frontend only)
  const footerForm = document.getElementById("footerContactForm");
  if (footerForm) {
    footerForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const email = this.querySelector('[name="email"]').value.trim();

      if (!email) {
        alert("Por favor, ingresa tu email.");
        return;
      }

      alert("¡Te has suscrito exitosamente!");
      this.reset();
    });
  }

  // ✅ INICIALIZAR SISTEMA DE BOOKING AVANZADO
  bookingManager.init();

  // ...otros inicializadores...
  contactFormManager.init();

  // Libro de Reclamaciones (complaint/queja form)
  complaintFormManager.init();

  // ...otros inicializadores...
  footerContactFormManager.init();

  console.log("✅ Todas las funcionalidades inicializadas");
});
